export const MEDIA_CENTER_LIST_REQUEST = "MEDIA_CENTER_LIST_REQUEST";
export const MEDIA_CENTER_LIST_SUCCESS = "MEDIA_CENTER_LIST_SUCCESS";
export const MEDIA_CENTER_LIST_FAIL = "MEDIA_CENTER_LIST_FAIL";

export const MEDIA_CENTER_DETAILS_REQUEST = "MEDIA_CENTER_DETAILS_REQUEST";
export const MEDIA_CENTER_DETAILS_SUCCESS = "MEDIA_CENTER_DETAILS_SUCCESS";
export const MEDIA_CENTER_DETAILS_FAIL = "MEDIA_CENTER_DETAILS_FAIL";

export const MEDIA_CENTER_DELETE_REQUEST = "MEDIA_CENTER_DELETE_REQUEST";
export const MEDIA_CENTER_DELETE_SUCCESS = "MEDIA_CENTER_DELETE_SUCCESS";
export const MEDIA_CENTER_DELETE_FAIL = "MEDIA_CENTER_DELETE_FAIL";

export const MEDIA_CENTER_UPDATE_REQUEST = "MEDIA_CENTER_UPDATE_REQUEST";
export const MEDIA_CENTER_UPDATE_SUCCESS = "MEDIA_CENTER_UPDATE_SUCCESS";
export const MEDIA_CENTER_UPDATE_FAIL = "MEDIA_CENTER_UPDATE_FAIL";
export const MEDIA_CENTER_UPDATE_RESET = "MEDIA_CENTER_UPDATE_RESET";

export const MEDIA_CENTER_ADD_REQUEST = "MEDIA_CENTER_ADD_REQUEST";
export const MEDIA_CENTER_ADD_SUCCESS = "MEDIA_CENTER_ADD_SUCCESS";
export const MEDIA_CENTER_ADD_FAIL = "MEDIA_CENTER_ADD_FAIL";

export const ADMIN_MEDIA_CENTER_LIST_REQUEST = "ADMIN_MEDIA_CENTER_LIST_REQUEST";
export const ADMIN_MEDIA_CENTER_LIST_SUCCESS = "ADMIN_MEDIA_CENTER_LIST_SUCCESS";
export const ADMIN_MEDIA_CENTER_LIST_FAIL = "ADMIN_MEDIA_CENTER_LIST_FAIL";